import { Controller } from "@hotwired/stimulus"

// Disables the submit button once a NON-Turbo form (data-turbo="false") is
// submitted, so a double click cannot enqueue the same generation twice.
// Turbo forms get the same protection from data-turbo-submits-with.
export default class extends Controller {
  static targets = ["button"]

  disable() {
    this.buttonTargets.forEach(button => {
      button.disabled = true
      if (button.dataset.submittingLabel) button.textContent = button.dataset.submittingLabel
    })
  }
}
